<template>
  <el-container>
    <div class="header-top">
      <img class="logo" src="../assets/images/logo.png" alt="" @click="home">
      <img class="bg" src="../assets/images/bg9.jpg" alt="">
      <div class="flex_row_center search" @click="toSearch">
        <span>搜索</span>
        <i class="el-icon-search"></i>
      </div>
    </div>
    <div class="header-menus">
      <el-header height="96px">
        <nav class="nav">
          <Menus/>
        </nav>
      </el-header>
    </div>
    <el-main style="padding: 0;min-height: calc(100vh - 326px);">
      <Content></Content>
    </el-main>
    <el-footer style="height: auto; padding: 0">
      <Footer></Footer>
    </el-footer>
  </el-container>
</template>

<script>
import Logo from './Logo.vue'
import Menus from './Menus.vue'
import Content from './Content.vue'
import Footer from './Footer.vue'

export default {
  components: {Logo, Menus, Content, Footer},
  data() {
    return {}
  },
  methods: {
    toSearch() {
      if (this.$route.path === '/module/search') return
      this.$router.push('/module/search')
    },
    home() {
      if (this.$route.path === '/home') return
      this.$router.push('/home')
    }
  }
}
</script>

<style lang="less" scoped>
.header-menus {
  background-color: #004b85;
  //background-color: #000080;
}

.header-top {
  width: 100%;
  height: 240px;
  position: relative;

  .search {
    position: absolute;
    right: 100px;
    z-index: 10;
    width: 110px;
    height: 40px;
    background: #004b85;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px 8px;
    border-radius: 20px;
    color: #fff;
    top: 130px;
    font-size: 18px;
    cursor: pointer;

    span {
      font-weight: bold;
      padding-right: 10px;
    }

    &:hover {
      opacity: .8;
    }
  }

  .bg {
    width: 100%;
    height: 100%;
    object-fit: fill;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
  }

  .logo {
    width: 360px;
    top: 60px;
    left: 180px;
    position: absolute;
    z-index: 10;
    cursor: pointer;
  }
}

header {
  width: 1200px;
  height: 96px;
  padding: 0 40px;
  margin: 0 auto;

  .nav {
    display: flex;
    justify-content: space-between;
    gap: 40px;

    position: relative;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    color: #fff;
  }
}
</style>
